$(document).ready(function(){
    // init Isotope
    var $grid = $('.items-container-grid').isotope({
        itemSelector: '.item-unit',
        layoutMode: 'fitRows',
        transitionDuration: '0.6s',
        filter: "*"
    });

// store filter for each group
    var filters = {};

    $('.filters').on( 'click', '.button', function( event ) {
        var $button = $( event.currentTarget );
        // get group key
        var $buttonGroup = $button.parents('.button-group');
        var filterGroup = $buttonGroup.attr('data-filter-group');
        // set filter for group
        filters[ filterGroup ] = $button.attr('data-filter');
        // combine filters
        var filterValue = concatValues( filters );
        // set filter for Isotope
        $grid.isotope({ filter: filterValue });
    });

// change is-checked class on buttons
    $('.button-group').each( function( i, buttonGroup ) {
        var $buttonGroup = $( buttonGroup );
        setCheckedName($buttonGroup);
        $buttonGroup.on( 'click', '.button', function( event ) {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            var $button = $( event.currentTarget );
            $button.addClass('is-checked');
            setCheckedName($buttonGroup);
        });
    });


    function setCheckedName($buttonGroup) {
        var checkedName = $buttonGroup.find('.button.is-checked').text();
        checkedName = (checkedName === 'any') ? '' : checkedName;
        $buttonGroup.parents('.dropdown').find('.filter-selected').text(checkedName);
    }

// flatten object by concatting values
    function concatValues( obj ) {
        var value = '';
        for ( var prop in obj ) {
            value += obj[ prop ];
        }
        return value;
    }

    function setDropdownWidth() {
        $('.btn.dropdown-toggle').each(function () {
            var $width = $(this).outerWidth();
            $(this).parents('.dropdown').find('.dropdown-menu').outerWidth($width);
        });
    }

    setDropdownWidth();
    $(window).resize(function() {
        setDropdownWidth();
    });
});